import axios from "axios";

// Generalized function for fetching All Packages By Category
export function fetchAllPackagesByCategoryApis(
  categoryId,
  currentPage,
  sortKey,
  sortDirection,
  filterBy
) {
  const params = {
    page: currentPage,
    sort_by: sortKey,
    sort_dir: sortDirection,
    filter_by: filterBy,
  };
  if (categoryId === "all") {
    return axios.get(`/admin/package-management/list-packages`, {
      params,
    });
  } else {
    return axios.get(`/admin/package-management/list-packages/${categoryId}`, {
      params,
    });
  }
}
